import XmlInterface from '@/utilities/xml/interfaces/XmlInterface'
import { JsonType, JsonItemType } from '@/utilities/xml/types/JsonType'
import { XmlOptions } from '@/utilities/xml/types/XmlOptions'

export default class Xml implements XmlInterface {
  private readonly document: Document
  private readonly options: XmlOptions
  private readonly xmlNamespace: string

  constructor(document: Document, options: XmlOptions = {}) {
    this.document = document
    this.options = { version: '1.0', encoding: 'UTF-8', ...options }
    this.xmlNamespace = options.namespace ?? ''
  }

  isAttribute(key: string): boolean {
    return key.startsWith('_')
  }

  isObjectValue(value: unknown): value is JsonType {
    return typeof value === 'object' && value !== null
  }

  getXmlTag(version: string | number = '1.0', encoding: string = 'UTF-8'): string {
    return `<?xml version="${version}" encoding="${encoding}" ?>`
  }

  handleElement(tag: string, item: JsonItemType, parent?: Element): Element {
    const element = this.document.createElementNS(this.xmlNamespace, tag)

    if (Array.isArray(item)) {
      item.forEach(value => this.handleElement(tag, value, parent))
      return element
    } else if (this.isObjectValue(item)) {
      this.parseFromJson(item, element)
    } else {
      element.textContent = String(item)
    }

    if (parent) {
      parent.appendChild(element)
    }

    return element
  }

  parseFromJson(json: JsonType, parent?: Element): string {
    let element: Element | undefined

    Object.keys(json).forEach(key => {
      const value: JsonItemType = json[key]

      if (this.isAttribute(key) && parent) {
        return parent.setAttribute(key.replace(/^_/, ''), String(value))
      }

      element = this.handleElement(key, value, parent)
    })

    if (parent) {
      return parent.outerHTML
    }

    return `${this.getXmlTag(this.options.version, this.options.encoding)}${element?.outerHTML}`
  }
}
